import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'

import { Button, Dialog } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { selectConnectBankPath } from '@/features/banking/banking.selectors'
import { ImageBackgroundColors } from '@/styles'
import {
  OFFER_SOURCES,
  useBankingAnalytics,
} from '@/features/banking/analytics'

const HEADING = 'Activate Heard Banking'
const DESCRIPTION =
  "Congratulations on your new Heard Banking account! Now that you're approved, connect Heard banking to your bookkeeping."
const ILLUSTRATION_SRC =
  'https://heard-images.s3.amazonaws.com/assets/piggy-bank-card.svg'
const ILLUSTRATION_ALT = 'Heard Banking'
const ILLUSTRATION_COLOR = ImageBackgroundColors.GREEN

export interface PlaidConnectReminderModalProps {
  onDismiss: () => void
}

export const PlaidConnectReminderModal = ({
  onDismiss,
}: PlaidConnectReminderModalProps) => {
  const navigate = useNavigate()
  const connectBankPath = useReselector(selectConnectBankPath)
  const { trackOfferViewed, trackOfferClicked } = useBankingAnalytics()

  useEffect(() => {
    trackOfferViewed(OFFER_SOURCES.BankingPlaidConnectReminderModal)
  }, [trackOfferViewed])

  const handleNext = () => {
    trackOfferClicked(OFFER_SOURCES.BankingPlaidConnectReminderModal)
    // Suppress for 24h on Next click. If the user completes Plaid activation,
    // `selectBankingDisplayState` flips to 'Normal' and the gate naturally
    // turns off; if they bail out of the Connect Stage without connecting,
    // we don't want the modal to re-fire on the next page they land on.
    onDismiss()
    navigate(connectBankPath)
  }

  return (
    <Dialog open onClose={onDismiss}>
      <Dialog.Content
        heading={HEADING}
        description={DESCRIPTION}
        illustrationSrc={ILLUSTRATION_SRC}
        illustrationAlt={ILLUSTRATION_ALT}
        illustrationColor={ILLUSTRATION_COLOR}
        onDismiss={onDismiss}
      >
        <Dialog.Footer>
          <Button variant="secondary" onClick={onDismiss}>
            Remind Me Later
          </Button>
          <Button onClick={handleNext} iconRight={faChevronRight}>
            Next
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
